export default __webpack_public_path__ + "static/sharing-f4d02431fc6847a7f0e07672d5c5911b.png";